// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1f2NA","overflowing":"ReadFullNote_overflowing__3aExI"};